const homePageWatcher = (route) => {
  if (route === '/') {
    return true
  }
  return false
}

export {
  homePageWatcher
}
